import { printerReducer } from "./reducer";

export default printerReducer;
